import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { handleFormError } from '@/utils/helpers.js'
import { toast } from 'sonner'

export default function useEditTransactionCategory(transactionCategoryId) {
  const queryClient = useQueryClient()
  const action = async ({
    name = null,
    description = null,
    default_vault_id,
  }) => {
    return await httpClient.put(
      `/team/transaction-category/${transactionCategoryId}`,
      {
        name,
        description,
        default_vault_id,
      },
    )
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        showToast: true,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['transaction-categories'],
      })
      toast.success('Changes saved successfully')
    },
  })

  return {
    editTransactionCategory: mutation.mutateAsync,
  }
}
